// Service layer del rol jefe_cocina (F11 — workflow cambio de dieta post-preparacion).
// Los tipos siguen 1:1 los schemas Pydantic en backend/app/schemas/solicitud_cambio_dieta.py
// (PR T7, branch sprint5/07-api-jefe-cocina-f11). Si T7 cambia el contrato, ajustar aqui.
import { api } from '../lib/api'

export type EstadoSolicitud =
  | 'PENDIENTE_CHEF'
  | 'APROBADA'
  | 'RECHAZADA'
  | 'EXPIRADA'

export type AccionMerma =
  | 'DESCARTAR'
  | 'REUTILIZAR_PACIENTE_X'
  | 'PERSONAL_COCINA'
  | 'NO_APLICA'

export interface SolicitudCambioListItem {
  id: number
  comida_elegida_id: number
  estado: EstadoSolicitud
  solicitado_at: string  // ISO 8601
  paciente_id: number
  paciente_nombre: string
  habitacion: string
  sede_id: number
  dieta_original_id: number
  dieta_original_nombre: string
  dieta_nueva_id: number
  dieta_nueva_nombre: string
  motivo_enfermera: string
  tiempo_transcurrido_minutos: number
  escalada_chef_corp: boolean
  escalada_admin: boolean
}

export interface SolicitudCambioResponse {
  id: number
  comida_elegida_id: number
  estado_comida_al_solicitar: string
  dieta_original_id: number
  dieta_nueva_id: number
  motivo_enfermera: string
  doctor_autoriza_id: number | null
  solicitado_por_usuario_id: number
  solicitado_at: string
  estado: EstadoSolicitud
  chef_decision_usuario_id: number | null
  chef_decision_at: string | null
  motivo_chef: string | null
  accion_merma: AccionMerma | null
  comida_nueva_id: number | null
  escalada_chef_corp: boolean
  escalada_admin: boolean
  audit_override: boolean
  puede_revertir: boolean
}

export interface KdsCard {
  comida_id: number
  paciente_id: number
  paciente_nombre: string
  habitacion: string
  sede_id: number
  dieta_id: number
  dieta_nombre: string
  tiempo_id: number
  tiempo_nombre: string
  fecha: string  // ISO date
  estado: string
  tiene_solicitud_pendiente: boolean
  solicitud_id: number | null
}

export interface AprobarBody {
  accion_merma: AccionMerma
  observacion_chef: string | null
}

export interface RechazarBody {
  motivo_chef: string
}

export const jefeCocinaApi = {
  listarPendientes: (): Promise<SolicitudCambioListItem[]> =>
    api.get('/jefe-cocina/pendientes-aprobacion').then((r) => r.data),

  listarKdsResumen: (): Promise<KdsCard[]> =>
    api.get('/jefe-cocina/kds-resumen').then((r) => r.data),

  aprobar: (id: number, body: AprobarBody): Promise<SolicitudCambioResponse> =>
    api.post(`/solicitud-cambio-dieta/${id}/aprobar`, body).then((r) => r.data),

  rechazar: (id: number, body: RechazarBody): Promise<SolicitudCambioResponse> =>
    api.post(`/solicitud-cambio-dieta/${id}/rechazar`, body).then((r) => r.data),

  revertir: (id: number): Promise<SolicitudCambioResponse> =>
    api.post(`/solicitud-cambio-dieta/${id}/revertir`).then((r) => r.data),

  listarHistorialEscaladas: (): Promise<SolicitudCambioListItem[]> =>
    api
      .get('/solicitud-cambio-dieta', { params: { estado: 'APROBADA', limit: 50 } })
      .then((r) => (r.data as SolicitudCambioListItem[]).filter((s) => s.escalada_chef_corp || s.escalada_admin)),
}
